// ── 통합 일일콜 메뉴: 등록할 회사 고르기 (2026-10-13, 통합 계획 3단계 5번) ─────────────
//   통합 메뉴는 여러 회사 콜을 함께 보므로, 새 콜을 어느 회사 것으로 등록할지 정해야 한다(사용자 결정 5-a, 서버도 재확인).
//   담당자를 고르면 그 사람 회사로 저절로 맞춰지고(CallRegister), 다른 회사 콜일 때만 여기서 바꾼다(2026-10-14 결정).
//   회사가 바뀌면 그 회사 상품 목록을 다시 읽는다(useCallRegisterHandlers). 위치: 등록 폼 바로 위 한 줄.
import React from 'react';
import { companyColor } from '../../admin/integratedmenu/integratedFeatureMeta';
// 단추 글자 = 작업 대상과 같은 회사 이름(2026-10-15 — 전엔 SUNCREAM·SUNCREAM2 코드). 고르는 값은 그대로 코드
import { useCompanyNames } from '../../admin/adminlayout/useCompanyNames';

const rowStyle = (isMobile) => ({
  display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
  padding: isMobile ? '10px 12px' : '10px 14px',
  border: '1px solid var(--border)', borderRadius: 10, background: 'var(--bg-card)',
});
const labelStyle = { fontSize: 13, fontWeight: 800, color: 'var(--text)', marginRight: 4 };
const hintStyle = { fontSize: 12, color: '#dc2626', fontWeight: 600 };
const noteStyle = { fontSize: 12, color: 'var(--text-muted)' };
const btnStyle = (on, code) => {
  const c = companyColor(code);
  return {
    height: 32, padding: '0 14px', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 700,
    border: `1.5px solid ${on ? c.bg : 'var(--border)'}`,
    background: on ? c.bg : 'var(--bg-card)', color: on ? c.fg : 'var(--text-sub)',
  };
};

/**
 * @param {string[]} props.companies  메뉴 회사 코드들
 * @param {string}   props.value      고른 회사('' = 아직 안 고름)
 * @param {(code:string)=>void} props.onChange
 */
export function CallCompanyPicker({ companies, value, onChange, isMobile }) {
  const nameOf = useCompanyNames();
  return (
    <div style={rowStyle(isMobile)}>
      <span style={labelStyle}>등록할 회사</span>
      {companies.map((code) => (
        <button key={code} type="button" style={btnStyle(value === code, code)}
          aria-pressed={value === code} onClick={() => onChange(code)}>
          {nameOf(code)}
        </button>
      ))}
      {value
        ? <span style={noteStyle}>담당자를 고르면 그 회사로 맞춰집니다. 다른 회사 콜이면 바꿔 주세요.</span>
        : <span style={hintStyle}>회사를 골라야 등록할 수 있습니다.</span>}
    </div>
  );
}
